import React from 'react';
import Panel from 'components/v2/panels/Panel';
import classnames from 'classnames';

export default function Card({ title, className, children }) {
  return (
    <Panel className={classnames(className)}>
      <div className="flex items-center justify-between">
        <h3>{title}</h3>
        {children}
      </div>
    </Panel>
  );
}
